import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { DataNotCollectedIssue, FacilityIssue } from "../types";

import "./styles.scss";

interface IFacilityIssueTextProps {
  issue: FacilityIssue;
}

export const FacilityIssueText: React.FunctionComponent<
  IFacilityIssueTextProps
> = (props) => {
  const { issue } = props;

  if (issue.title === "data_not_collected") {
    return <DataNotCollectedIssueText issue={issue as DataNotCollectedIssue} />;
  }

  return <div>{issue.title}</div>;
};

interface IDataNotCollectedIssueTextProps {
  issue: DataNotCollectedIssue;
}

const DataNotCollectedIssueText: React.FunctionComponent<
  IDataNotCollectedIssueTextProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string, params?: Record<string, string>) =>
    _t(`facilityIssues.dataNotCollectedIssue.${key}`, params);

  const { data_last_collected_at } = props.issue.params;
  const dataLastCollectedAt = data_last_collected_at
    ? dayjs(data_last_collected_at).format("YYYY/MM/DD")
    : undefined;

  return (
    <div className="facility-issue-text">
      <span className="facility-issue-text-title">{t("title")}</span>
      <span className="facility-issue-text-body">
        {dataLastCollectedAt
          ? t("last_collected_at", {
              data_last_collected_at: dataLastCollectedAt,
            })
          : t("last_collected_at_unknown")}
      </span>
    </div>
  );
};
